import { createGlobalStyle } from "styled-components";
const fonts = createGlobalStyle`
  @font-face {
     font-family: 'zinc';
     src: url('./fonts/zing.rust-demo-base.otf');
  }
`;
export default fonts;
